const searchParams = new URLSearchParams(window.location.search)
const loggingEnabled = searchParams.has('debug')
const logPrefix = 'Mediavine Video'
const logPrefixStyle =
  'background: teal; color: white; border-radius: 2px; padding: 1px 4px;'

export class Logger {
  private prefix: string
  private style: string
  public enabled: boolean

  constructor(prefix: string, style: string, enabled: boolean) {
    this.prefix = prefix
    this.style = style
    this.enabled = enabled
  }

  public log(...rest): void {
    this.proxy('log', ...rest)
  }

  public info(...rest): void {
    this.proxy('info', ...rest)
  }

  public warn(...rest): void {
    this.proxy('warn', ...rest)
  }

  public error(...rest): void {
    this.proxy('error', ...rest)
  }

  private proxy(method: 'log' | 'info' | 'warn' | 'error', ...rest) {
    if (!this.enabled) {
      return
    }
    console[method](`%c${this.prefix}`, this.style, ...rest)
  }
}

export const logger = new Logger(logPrefix, logPrefixStyle, loggingEnabled)
